import { AnalyticsMetric, MetricCardType } from '../const';
import type { AllMetricType } from '../types';

export const getTooltipContent = (type: AllMetricType): string => {
  switch (type) {
    case AnalyticsMetric.SUCCESS_RATE:
      return 'Percentage of conversations in which the agent successfully resolved all user queries.';
    case AnalyticsMetric.ERROR_RATE:
      return 'Percentage of conversations with one or more misunderstanding or issue identified between user and agent.';
    case AnalyticsMetric.USER_ABANDONED:
      return 'Percentage of customers who hang up before issue resolution.';

    case MetricCardType.DURATION_SECONDS:
      return 'The average duration of the active conversation between the agent and the customer.';
    case MetricCardType.AVERAGE_RESPONSE_TIME_SECONDS:
      return 'The average time it takes AI to respond to the user.';
    case MetricCardType.CSAT_STARS:
      return 'Directly reflects user experience and effectiveness of the AI.';

    case AnalyticsMetric.SYSTEM_AVAILABILITY:
      return 'Percentage of time the system is operational.';
    case AnalyticsMetric.TOPIC_TAGS:
      return 'The total number of conversations, segmented by predefined categories such as service type or inquiry topic.';
    case AnalyticsMetric.MOOD_TAGS:
      return 'The total number of conversations, segmented by customer mood such as positive, negative or neutral.';

    case AnalyticsMetric.HUMAN_ESCALATION:
      return 'Frequency of transfers from AI to human agents.';
    case AnalyticsMetric.MAX_CONCURRENCY:
      return 'Maximum concurrent agents working in peak time.';

    default:
      return 'Additional information about this metric.';
  }
};
